import React from 'react';
import { Spin } from 'antd';
import { LeadTimePriceOptions } from '../LeadTimeOptions';
import { QuoteLineItemProps } from '@partsbadger/types';
import dayjs from 'dayjs';

interface ILeadTimeSectionProps {
    part: QuoteLineItemProps;
    loading: boolean;
    onUpdateItemPrice: (leadTimeOptionId: string) => void;
}

export const LeadTimeSection: React.FC<ILeadTimeSectionProps> = ({ part, loading, onUpdateItemPrice }) => {
    const getExpirationDate = () => {
        // find an option with the type 'expedited' and return the expiration date
        const expeditedOption = part?.pricing_options?.prices_by_quantity?.[part?.quantity]?.find(
            option => option.type === 'Expedited'
        );
        if (expeditedOption) {
            return dayjs(expeditedOption?.expiration_date).format('MM-DD-YYYY hh:mm A') + ' (CST)';
        }
    };
    return (
        <>
            {part?.safe_auto_quote && !part?.needs_manual_quote ? (
                <>
                    <div>
                        {part.is_fastlane_safe && getExpirationDate() ? (
                            <div className="flex items-center text-gray-700 mb-2">
                                <span className="font-light">
                                    All Expedited options expire at:{' '}
                                    <span className="font-bold">{getExpirationDate()}</span>
                                </span>
                            </div>
                        ) : null}
                    </div>

                    <Spin spinning={loading}>
                        <LeadTimePriceOptions
                            direction="column"
                            lineItem={part}
                            handleChange={leadTimeOptionId => {
                                if (leadTimeOptionId) {
                                    onUpdateItemPrice(leadTimeOptionId);
                                }
                            }}
                        />
                        {part.is_fastlane_safe && part.safe_auto_quote && (
                            <div className="flex items-center text-gray-600 font-size-sm mb-4">
                                <span>{part.material_disclaimer_message}</span>
                            </div>
                        )}
                    </Spin>
                </>
            ) : null}
        </>
    );
};
